// extracted by mini-css-extract-plugin
module.exports = {"root":"DateRow_root__2Hxrp","customDate":"DateRow_customDate__1fGjd"};